import axios from 'axios';
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function markVehicleSold(vehicleId, sellerEmail) {
  const { data } = await axios.patch(`${API}/vehicles/${vehicleId}`, {
    seller_email: sellerEmail,
    status: 'sold',
  });
  return data;
}

export async function relistVehicle(vehicleId, sellerEmail) {
  const { data } = await axios.patch(`${API}/vehicles/${vehicleId}`, {
    seller_email: sellerEmail,
    status: 'active',
  });
  return data;
}

export async function getMyProfile() {
  const { data } = await axios.get(`${API}/profile/me`, { withCredentials: true });
  return data;
}
